enum BackendPreFillFieldType {
  EMAIL = 'contact_email',
}

export default BackendPreFillFieldType
